import React, { useState, useMemo } from "react";
import { useUnifiedFilters } from "../../hooks/useUnifiedFilters";
import { ReminderView } from "../../types/reminderTypes";
import { debounce } from "../../utils/debounceUtils";
import styles from "./SearchInput.module.scss";

interface SearchInputProps {
  placeholder: string;
  searchType: "patient-dual" | "article-patient-dual" | "article-only";
  selectedView: ReminderView;
  className?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  placeholder,
  searchType,
  selectedView,
  className = "",
}) => {
  const { filters, updateFilters } = useUnifiedFilters(selectedView);
  const [localValue, setLocalValue] = useState(filters.search || "");

  const debouncedUpdate = useMemo(
    () =>
      debounce((value: string) => {
        updateFilters({ search: value || undefined });
      }, 300),
    [updateFilters]
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLocalValue(value);
    debouncedUpdate(value);
  };

  const handleClear = () => {
    setLocalValue("");
    updateFilters({ search: undefined });
  };

  return (
    <div className={`${styles.searchInputContainer} ${className}`}>
      <div className={styles.inputWrapper}>
        <input
          type="text"
          placeholder={placeholder}
          value={localValue}
          onChange={handleChange}
          className={styles.searchInput}
        />
        {localValue && (
          <button
            onClick={handleClear}
            className={styles.clearButton}
            type="button"
            aria-label="Clear search"
          >
            ×
          </button>
        )}
      </div>
      <div className={styles.searchIcon}>🔍</div>
    </div>
  );
};

export default SearchInput;
